module.exports = "pegasus/assets/image-4-basic.png";